import { render, staticRenderFns } from "./NewCard.vue?vue&type=template&id=4189273e&scoped=true&"
import script from "./NewCard.vue?vue&type=script&lang=js&"
export * from "./NewCard.vue?vue&type=script&lang=js&"
import style0 from "./NewCard.vue?vue&type=style&index=0&id=4189273e&prod&scoped=true&lang=css&"
import style1 from "./NewCard.vue?vue&type=style&index=1&id=4189273e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4189273e",
  null
  
)

export default component.exports